<template>
  <el-card>

    <el-form ref="ruleForm" :rules="rules" :model="form">
      <el-form-item label="表单提交时间：" style="width: 600px;" prop="value">
        <el-date-picker
          v-model="form.value"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">导出</el-button>
      </el-form-item>
    </el-form>
    <!-- <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog> -->
  </el-card>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import moment from "moment";

const { mapGetters } = createNamespacedHelpers("warranties");
import store from "@/store";
export default {
  data() {
    return {
      form: {
        value: "",
      },
      rules: {
        value: [{ required: true, message: "请选择时间", trigger: "blur" }],
      },
    };
  },
  methods: {
    async onSubmit() {
      await this.$formHelper.promisedValidate(this.$refs.ruleForm);
      let query = {
        start: this.date(this.form.value[0]),
        end: this.date(this.form.value[1]),
      };
      this.$linkHelper.redirect("electric-piano-order-export", query);
    },
    date(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
};
</script>
